export const UPDATE_COURSE_IN_PROGRESS_FLAG = "UpdateCourseInProgressFlag";
export const LOAD_SUBJECTS = "subjects/load";
export const LOADING = "loader/showandhide";
